<div class="ss-formfield" *ngIf="showInfo">
  <!-- label -->
  <kendo-label [text]="'module.customer-address.component.label_customer_address' | translate"></kendo-label>
  <!-- table-->
  <table class="ss-customer-shipping-info-table">
    <tr *ngIf="customerAddress.transportFeeAmount != null">
      <th>{{ "module.customer-address.model.transportFeeAmount" | translate }}</th>
      <td>{{customerAddress.transportFeeAmount | dollarSignByLocal}}</td>
    </tr>
    <tr *ngIf="customerAddress.minimumAmountForFreeTransportFee != null">
      <th>{{ "module.customer-address.model.minimumAmountForFreeTransportFee" | translate }}</th>
      <td>{{customerAddress.minimumAmountForFreeTransportFee | dollarSignByLocal}}</td>
    </tr>
    <tr *ngIf="customerAddress.freeTransportFeeAmount != null">
      <th>{{ "module.customer-address.model.freeTransportFeeAmount" | translate }}</th>
      <td>{{customerAddress.freeTransportFeeAmount | dollarSignByLocal}}</td>
    </tr>
    <tr *ngIf="customerAddress.compteDeCollecte != null">
      <th>{{ "module.customer-address.model.compteDeCollecte" | translate }}</th>
      <td>{{customerAddress.compteDeCollecte}}</td>
    </tr>
    <tr *ngIf="customerAddress.orderDisposition != null">
      <th>{{ "module.customer-address.model.orderDisposition" | translate }}</th>
      <td>{{customerAddress.orderDisposition | uppercase}}</td>
    </tr>
    <tr *ngIf="customerAddress.shipVia != null">
      <th>{{ "module.customer-address.model.shipVia" | translate }}</th>
      <td>{{customerAddress.shipVia}}</td>
    </tr>
  </table>
</div>